export default "__VITE_ASSET__CWmDupdi__"